export default class StateModel {
	constructor({ comment, products }) {
		this.comment = comment;
		this.products = products;
	}
}